(function ie11($, Drupal) {
  const isIE11 = /msie|trident/i.test(navigator.userAgent);

  if (!isIE11) {
    // Bail if we're not using IE11.
    return false;
  }

  // Now we can run any IE only JS.

  // Load custom properties polyfill.
  loadjs(
    `themes/custom/rutherford/libraries/ie11-custom-properties/ie11CustomProperties.js`,
  );

  // Voyager targets modern browsers so we should warn users old older browsers
  // that their experience won't be as good as it could be. We showed a similar
  // message on Bidx1 (BIDX1-388) at the client's request. If the client has
  // paid extra for IE11 support then we should probably not show this message,
  // or show a toned down version of it.
  const messageInterface = new Drupal.Message();
  const ieMessage =
    'You are using Microsoft Internet Explorer 11, which was first released ' +
    'in 2013. For a better experience on this website and across the whole ' +
    'internet, we recommend you use ' +
    '<a href="https://www.microsoft.com/edge">Microsoft Edge</a>, ' +
    '<a href="https://www.google.com/chrome/browser/desktop">Google Chrome</a>, ' +
    'or <a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox</a> – ' +
    'or view this site on a different device if you cannot change browser. ' +
    'Despite our best efforts, this site may not function in such an ' +
    'old browser, or it may be slower or only partially functional.';

  messageInterface.add(Drupal.t(ieMessage), { type: 'error' });

  // Load IE only CSS for fallback for things like CSS grid or custom properties.
  loadjs(`themes/custom/rutherford/dist/ie11.css`);

  Drupal.behaviors.removeClassesIE11 = {
    attach: function removeClassesIE11Init(context) {
      if (!isIE11) return false;

      const dataAttributeKey = 'remove-classes-ie11';
      const dataAttributeKeyCamel = _.camelCase(dataAttributeKey);

      $(`[data-${dataAttributeKey}]`, context).each(
        function removeClassesIE11RemoveClass() {
          $(this).removeClass($(this).data(dataAttributeKeyCamel));
        },
      );
    },
  };
})(jQuery, Drupal);
